// A retained UI request is never authority: every replay goes to the same owner/current native route. It only keeps the
// ONE original request and its operation key across a closed panel or a reload of this tab, so reopening never makes a
// successor. Its key names the coherent person and company and the exact selected saved version, so another account,
// company or version never inherits it. sessionStorage that cannot be read or written is said so, never guessed.
export type RetainedPerson = { userId: string; companyId: string };

export const retainedKey = (
  scope: 'function-write' | 'schedule',
  person: RetainedPerson,
  parts: readonly string[],
) => `poneva.${scope}.v1:${JSON.stringify([person.userId, person.companyId, ...parts])}`;

/** The retained value, null when none; throws when storage is unavailable or the value is not ours. */
export function readRetained<T>(key: string, valid: (value: unknown) => value is T): T | null {
  const raw = window.sessionStorage.getItem(key);
  if (raw === null) return null;
  const value: unknown = JSON.parse(raw);
  if (!valid(value)) throw new Error('retained_request_unreadable');
  return value;
}

export function writeRetained(key: string, value: unknown | null) {
  if (value === null) window.sessionStorage.removeItem(key);
  else window.sessionStorage.setItem(key, JSON.stringify(value));
}
